var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 39,
    viewBox: "0 0 86 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94742 0C-0.633646 1.61168 -0.378598 7.38686 0.446559 10.073L4.94742 33.3848C6.56772 38.9105 9.0732 39.3326 10.1234 38.853H76.061C80.5618 38.853 81.537 35.2075 81.462 33.3848L85.2877 10.073C87.8082 2.24484 83.0373 0.0959333 80.3368 0H4.94742Z",
    fill: "url(#paint0_linear_458_16)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_16",
    x1: 28,
    y1: -5.71824e-7,
    x2: 62,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35DBC3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector7);
export default __webpack_public_path__ + "static/media/Vector-7.e3a7be8ce82c321e68a29fa863e860a2.svg";
export { ForwardRef as ReactComponent };